import React from 'react';
import styled from 'styled-components';
import SliderBar from './dev/SliderBarSearch/SliderBar'
import { connect } from 'react-redux'

const ChannelSliderBar = (props) => {
    const { messages, SetSliderRange, urlArgs: {
            subscriberCountFrom, subscriberCountTo,
            recentAvgViewCountFrom, recentAvgViewCountTo,
            recentAvgEngageRateFrom, recentAvgEngageRateTo,
            monthSubscriberCountFrom, monthSubscriberCountTo,
            monthSubscriberRateFrom, monthSubscriberRateTo,
            monthViewCountFrom, monthViewCountTo,
            monthViewRateFrom, monthViewRateTo,
        }
    } = props
    return (
        <ChannelSliderBarWrap>
            <SubscriberCount id="user_tour_infolist_2">
                <SliderBar sliderTitle={messages.subscribers} sliderTitleDesc={[messages.dataDesc_subscriberCount]} onAfterChange={SetSliderRange(`subscriberCount`)} min={10000} max={2000000} range={[subscriberCountFrom, subscriberCountTo]}></SliderBar>
            </SubscriberCount>
            <RecentAverageView>
                <SliderBar sliderTitle={messages['infoList_20_avg_views']} sliderTitleDesc={[[`${messages['20_avg_views']} ${messages.dataDesc_equal}`,{numerator: messages.dataDesc_recentAvgViewCount_2, denominator: 20}, messages.dataDesc_recentAvgViewCount_3]]} onAfterChange={SetSliderRange(`recentAvgViewCount`)} min={0}  max={2000000} range={[recentAvgViewCountFrom, recentAvgViewCountTo]}></SliderBar>
            </RecentAverageView>
            <RecentAverageEngage>
                <SliderBar sliderTitle={messages['infoList_20_avg_engage']} sliderTitleDesc={[[`${messages['20_avg_engage']} ${messages.dataDesc_equal}`,{numerator: messages.dataDesc_recentAvgEngageRate_2, denominator: messages.dataDesc_recentAvgEngageRate_3}, messages.dataDesc_recentAvgEngageRate_4]]} onAfterChange={SetSliderRange(`recentAvgEngageRate`)} min={0} max={7} range={[recentAvgEngageRateFrom, recentAvgEngageRateTo]}></SliderBar>
            </RecentAverageEngage>
            <MonthSubscriber>
                <SliderBar sliderTitle={messages.monthly_subscribers} sliderTitleDesc={[messages.dataDesc_monthSubscriberCount]} onAfterChange={SetSliderRange(`monthSubscriberCount`)} min={0} max={30000} range={[monthSubscriberCountFrom, monthSubscriberCountTo]}></SliderBar>
            </MonthSubscriber>
            <MonthSubscriberGrowth>
                <SliderBar sliderTitle={messages.monthly_subscriptions_growth} sliderTitleDesc={[[`${messages.monthSubscriberRate} ${messages.dataDesc_equal}`,{numerator: messages.monthSubscriberCount, denominator: messages.dataDesc_todaySubscriberRate_2}, messages.dataDesc_monthSubscriberRate_2]]} onAfterChange={SetSliderRange(`monthSubscriberRate`)} min={0} max={30} range={[monthSubscriberRateFrom, monthSubscriberRateTo]}></SliderBar>
            </MonthSubscriberGrowth>
            <MonthView>
                <SliderBar sliderTitle={messages.monthly_views} sliderTitleDesc={[messages.dataDesc_monthViewCount]} onAfterChange={SetSliderRange(`monthViewCount`)} min={0} max={35000000} range={[monthViewCountFrom, monthViewCountTo]}></SliderBar>
            </MonthView>
            <MonthViewGrowth>
                <SliderBar sliderTitle={messages.monthly_views_growth} sliderTitleDesc={[[`${messages.monthViewRate} ${messages.dataDesc_equal}`,{numerator: messages.monthViewCount, denominator: messages.dataDesc_todayViewRate_2}, messages.dataDesc_monthSubscriberRate_2]]} onAfterChange={SetSliderRange(`monthViewRate`)} min={0} max={15} range={[monthViewRateFrom, monthViewRateTo]}></SliderBar>
            </MonthViewGrowth>
        </ChannelSliderBarWrap>
    )
}
const mapStateToProps = state => {
    return {
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(ChannelSliderBar);
const ChannelSliderBarWrap = styled.div`
    display: Grid;
    grid-template-columns: repeat(12,1fr);    
    grid-template-rows: 110px 116px; 
    /* //因應英文跑版把110調成116 */
    grid-template-areas: 
    "SubscriberCount SubscriberCount SubscriberCount SubscriberCount RecentAverageView RecentAverageView RecentAverageView RecentAverageView RecentAverageEngage RecentAverageEngage RecentAverageEngage RecentAverageEngage "
    "MonthSubscriber MonthSubscriber MonthSubscriber MonthSubscriberGrowth MonthSubscriberGrowth MonthSubscriberGrowth MonthView MonthView MonthView MonthViewGrowth MonthViewGrowth MonthViewGrowth ";
    grid-gap: 1px;
    width: 100%;
    height: 100%;
    background-color: #e6e6e6;
`
const Field = styled.div`
    padding: 20px;
    background-color: #fff;
    .ant-slider-rail {
        background-color: #e6e6e6;
    }
    .ant-slider-track {
        background-color: rgba(222,6,6,.5);
    }
    .ant-slider-handle {
        border: 2px solid #e6e6e6;
        &:focus {
            border: 2px solid #e94242;  
        }
        &.ant-tooltip-open {
            border: 2px solid #e94242;  
        }
    }
    .ant-slider:hover {
        .ant-slider-track {
            background-color: #e94242;        
        }
        .ant-slider-handle:not(.ant-tooltip-open) {
            border: 2px solid #e6e6e6;
        }
    }  
`
const SubscriberCount = Field.extend`
    grid-area: SubscriberCount;    
`
const RecentAverageView = Field.extend`
    grid-area: RecentAverageView;
`
const RecentAverageEngage = Field.extend`
    grid-area: RecentAverageEngage;
`
const MonthSubscriber = Field.extend`
    grid-area: MonthSubscriber;
`
const MonthSubscriberGrowth = Field.extend`
    grid-area: MonthSubscriberGrowth;
`
const MonthView = Field.extend`
    grid-area: MonthView;
`
const MonthViewGrowth = Field.extend`
    grid-area: MonthViewGrowth;
`


// WEBPACK FOOTER //
// ./src/InfoList/Search/ChannelSliderBar.js